// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608110924/js/" + chunkId + "." + {"44":"96882c08","225":"fde2341f","481":"3d5970c7","486":"e37c7c53","770":"3cc84062"}[chunkId] + ".0.5793005917205151.chunk.js";
};